<template>
  <div class="w-100 receipt">
    <div v-if="hasImage" class="d-flex justify-end align-center w-100" style="gap: 15px">
      <div><span class="font-weight-medium"> CTE:</span> {{ receiptCte }}</div>
      <div><span class="font-weight-medium"> NFE:</span> {{ receiptNfe }}</div>
    </div>

    <div class="w-100">
      <div :class="`w-100`" style="position: relative">
        <img v-if="hasImage" :src="receiptImage" class="rounded w-100 cursor-pointer mb-2" />
        <div v-else class="w-100 d-flex align-center justify-space-between py-2">
          <v-icon color="#717171"> mdi-image-remove </v-icon>

          <div class="d-flex justify-end align-center w-100" style="gap: 15px">
            <div><span class="font-weight-medium"> CTE:</span> {{ receiptCte }}</div>
            <div><span class="font-weight-medium"> NFE:</span> {{ receiptNfe }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    receipt: {
      type: Object,
      default: null
    }
  },

  data: () => ({
    isSelected: false,
    isExpanded: false
  }),

  computed: {
    hasImage() {
      const { srcImage: image } = this.receipt;
      return image !== null;
    },

    receiptCte() {
      const { receipt } = this;
      if (receipt) {
        return receipt.numberCte;
      }
      return null;
    },

    receiptNfe() {
      const { receipt } = this;
      if (receipt) {
        return receipt.numberNfe;
      }
      return null;
    },

    receiptImage() {
      const { receipt } = this;
      if (receipt) {
        return receipt.srcImage;
      }
      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.validated-flag {
  position: absolute;
  bottom: 3px;
}
.approve-remove-btn {
  position: absolute;
  top: 10px;
  left: 10px;
}

.details-header {
  background: rgb(228, 228, 228);
}
.selected-column {
  background: #2c8ef0 !important;
}
.v-input--selection-controls {
  margin-top: 0px !important;
}
</style>
